<template>
    <div style="position: absolute; top: 0px; left: 0px;">
        <div class="row mx-0 mb-0 p-0 gx-0">
            <div class="col-12 p-0">
                <img src="../../static/img/hiddenRealms.jpeg" alt="Flyer of the exposition" style="width: 100%;">
            </div>
        </div>
        <div class="row mx-0 mb-3 text-center fontHeebo p-3"
            style="background-color: black; color: white; display: flex; justify-content: center;">
            <div style="font-size: 16px;" class="py-2 col-12">
                ברוכים.ות הבאים.ות לתערוכה
            </div>
            <div style="font-size: 16px;" class="py-2 col-12">
                اهلا وسهلا بكم في المعرض
            </div>
              <div style="font-size: 16px;" class="py-2 col-12">
Welcome to the exhibition            </div>
            <div style="font-size: 32px; font-weight: 600;" class="py-2 col-12">
צְפוּנוֹת           </div>
            <div style="font-size: 32px; font-weight: 600;" class="py-2 col-12">
خفايا         </div>
              <div style="font-size: 19px; font-weight: 600;" class="py-2 col-12">
HIDDEN REALMS            </div>

        </div>
        <div class="row p-0 m-0 p-3">
            <div v-for="(artwork, index) in artworks" :key="index" @click="toggleAudio(index)"
                class="col-12 mb-2">
                <div class="audioButtonWide d-flex align-items-center"
                    :style="{ backgroundColor: isPlaying(index) ? '#f1750a' : '#FFFFFF' }">

                    <img :src="artwork.image" class="audioButtonImg">

                    <div class="flex-grow-1 d-flex align-items-center justify-content-between px-3" style="direction: rtl;">
                        <span class="audioButtonLabel" :style="{ color: isPlaying(index) ? 'white' : '#333' }">
                            {{ artwork.label }}
                        </span>
                        <svg v-if="!isPlaying(index)" xmlns="http://www.w3.org/2000/svg" width="28px" height="28px" fill="#63C4C3" class="bi bi-play-circle flex-shrink-0" viewBox="0 0 16 16">
                            <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14m0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16" />
                            <path d="M6.271 5.055a.5.5 0 0 1 .52.038l3.5 2.5a.5.5 0 0 1 0 .814l-3.5 2.5A.5.5 0 0 1 6 10.5v-5a.5.5 0 0 1 .271-.445" />
                        </svg>
                        <svg v-else xmlns="http://www.w3.org/2000/svg" width="28px" height="28px" fill="white" class="bi bi-pause-circle flex-shrink-0" viewBox="0 0 16 16">
                            <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14m0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16" />
                            <path d="M5 6.25a1.25 1.25 0 1 1 2.5 0v3.5a1.25 1.25 0 1 1-2.5 0zm3.5 0a1.25 1.25 0 1 1 2.5 0v3.5a1.25 1.25 0 1 1-2.5 0z" />
                        </svg>
                    </div>
                </div>
            </div>
        </div>
        <div class="row mx-0 mb-3 text-center fontHeebo p-3"
            style="background-color: black; color: white; display: flex; justify-content: center;">
                       <div style="font-size: 16px;" class="py-2 col-12">
    לחצו על התמונה המתאימה להסבר קולי
</div>
<div style="font-size: 16px;" class="py-2 col-12">
    اضغطوا على الصورة المناسبة للاستماع إلى شرح صوتي
</div>
<div style="font-size: 15px; direction: ltr;" class="py-2 col-12">
    Click on the matching image for an audio description
</div>
            <div style="font-size: 32px;font-weight: 600;" class="py-2">
                תודה שביקרתם.
            </div>
            <div style="font-size: 32px;font-weight: 600;" class="py-2">
                شكرا لزيارتكم.
            </div>
            <div style="font-size: 16px; " class="py-2">
                למידע על המוזיאון, על תערוכות ואירועים המתקיימים בו במהלך החודש מוזמנים לבקר באתר האינטרנט שלנו ולעקוב
                אחרינו בפייסבוק ובאינסטגרם
            </div>
            <div style="font-size: 16px; " class="py-2">
                للمزيد من المعلومات عن المتحف، عن المعارض والنشاطات التي يتم تنظيمها فيه خلال الشهر زوروا موقعنا في
                الانترنت وتابعونا...
            </div>

            <a :href="museumSite" style="text-decoration: none;">
                <div class="siteButton mt-2">
                    www.eindormuseum.co.il
                </div>
            </a>

            <div class="row d-flex justify-content-center align-items-center mt-4 mx-0" style="color:#63C4C3; gap: 30px;">
                <a :href="instaPage" class="links" style="text-decoration: none; width: auto;">
                    <svg xmlns="http://www.w3.org/2000/svg" width="25px" height="25px" fill="currentColor"
                        class="bi bi-instagram" viewBox="0 0 16 16">
                        <path
                            d="M8 0C5.829 0 5.556.01 4.703.048 3.85.088 3.269.222 2.76.42a3.917 3.917 0 0 0-1.417.923A3.927 3.927 0 0 0 .42 2.76C.222 3.268.087 3.85.048 4.7.01 5.555 0 5.827 0 8.001c0 2.172.01 2.444.048 3.297.04.852.174 1.433.372 1.942.205.526.478.972.923 1.417.444.445.89.719 1.416.923.51.198 1.09.333 1.942.372C5.555 15.99 5.827 16 8 16s2.444-.01 3.298-.048c.851-.04 1.434-.174 1.943-.372a3.916 3.916 0 0 0 1.416-.923c.445-.445.718-.891.923-1.417.197-.509.332-1.09.372-1.942C15.99 10.445 16 10.173 16 8s-.01-2.445-.048-3.299c-.04-.851-.175-1.433-.372-1.941a3.926 3.926 0 0 0-.923-1.417A3.911 3.911 0 0 0 13.24.42c-.51-.198-1.092-.333-1.943-.372C10.443.01 10.172 0 7.998 0h.003zm-.717 1.442h.718c2.136 0 2.389.007 3.232.046.78.035 1.204.166 1.486.275.373.145.64.319.92.599.28.28.453.546.598.92.11.281.24.705.275 1.485.039.843.047 1.096.047 3.231s-.008 2.389-.047 3.232c-.035.78-.166 1.203-.275 1.485a2.47 2.47 0 0 1-.599.919c-.28.28-.546.453-.92.598-.28.11-.704.24-1.485.276-.843.038-1.096.047-3.232.047s-2.39-.009-3.233-.047c-.78-.036-1.203-.166-1.485-.276a2.478 2.478 0 0 1-.92-.598 2.48 2.48 0 0 1-.6-.92c-.109-.281-.24-.705-.275-1.485-.038-.843-.046-1.096-.046-3.233 0-2.136.008-2.388.046-3.231.036-.78.166-1.204.276-1.486.145-.373.319-.64.599-.92.28-.28.546-.453.92-.598.282-.11.705-.24 1.485-.276.738-.034 1.024-.044 2.515-.045v.002zm4.988 1.328a.96.96 0 1 0 0 1.92.96.96 0 0 0 0-1.92zm-4.27 1.122a4.109 4.109 0 1 0 0 8.217 4.109 4.109 0 0 0 0-8.217zm0 1.441a2.667 2.667 0 1 1 0 5.334 2.667 2.667 0 0 1 0-5.334" />
                    </svg>
                </a>
                <a :href="facebookPage" class="links" style="text-decoration: none; width: auto;">
                    <svg xmlns="http://www.w3.org/2000/svg" width="25px" height="25px" fill="currentColor"
                        class="bi bi-facebook" viewBox="0 0 16 16">
                        <path
                            d="M16 8.049c0-4.446-3.582-8.05-8-8.05C3.58 0-.002 3.603-.002 8.05c0 4.017 2.926 7.347 6.75 7.951v-5.625h-2.03V8.05H6.75V6.275c0-2.017 1.195-3.131 3.022-3.131.876 0 1.791.157 1.791.157v1.98h-1.009c-.993 0-1.303.621-1.303 1.258v1.51h2.218l-.354 2.326H9.25V16c3.824-.604 6.75-3.934 6.75-7.951" />
                    </svg>
                </a>
            </div>
            <div class="row d-flex justify-content-center mt-4 pt-3" style="border-top: 1px solid white;">

                <a style="text-decoration: none;">

                    <div class="col-12 linksToWebsite ">
                        <!-- designed by Visuali -->
                    2026
                    </div>
                </a>
                <a :href="eifoany" style="text-decoration: none;">
                    <div class="col-12 linksToWebsite" style="font-family: 'segoeui';">
                        developped by Eifoany
                    </div>
                </a>
            </div>
        </div>

    </div>
</template>

<script>

export default {

    data() {
        return {
            eifoany: "https://eifoany.web.app/",
            visuali: "https://www.visuali.co.il/",
            showPause: false,
            facebookPage: "https://www.facebook.com/eindormuseum",
            instaPage: "https://www.instagram.com/eindormuseum?igsh=aWNwenJ3eWJqNG1p",
            museumSite: " www.eindormuseum.co.il",
            key: "",
            audioFiles: [
                'https://firebasestorage.googleapis.com/v0/b/visiteindormuseum.appspot.com/o/talesOfHome%2FStavHE.mp3?alt=media&token=72de411e-594d-4254-83ec-237e9cababef',
                'https://firebasestorage.googleapis.com/v0/b/visiteindormuseum.appspot.com/o/talesOfHome%2FNassrimHE.mp4?alt=media&token=d6035775-b818-4290-ad23-4fbf611c2e87',
                'https://firebasestorage.googleapis.com/v0/b/visiteindormuseum.appspot.com/o/talesOfHome%2FHitamHE.mp3?alt=media&token=7eed0a5e-d173-48a7-8c2d-6b6e3c88e3e2',
                'https://firebasestorage.googleapis.com/v0/b/visiteindormuseum.appspot.com/o/talesOfHome%2FnibalHE.mp3?alt=media&token=d13d27b3-6723-4121-b892-9fe0e2b6efec',
                'https://firebasestorage.googleapis.com/v0/b/visiteindormuseum.appspot.com/o/talesOfHome%2FUlaHE.mp3?alt=media&token=dc56b497-f9e0-40d2-b59f-bb1c493a3569',
                         ],
            artworks: [
                { label: 'על האמנית - ססיליה לינד',                      audio: 'https://firebasestorage.googleapis.com/v0/b/visiteindormuseum.appspot.com/o/hiddenRealms%2F3.mp3?alt=media&token=ab3718ab-8fdf-4bed-9c73-f7a4a55562f5',                image: 'https://firebasestorage.googleapis.com/v0/b/visiteindormuseum.appspot.com/o/hiddenRealms%2FWhatsApp%20Image%202026-04-23%20at%2011.46.53.jpeg?alt=media&token=a7bddfb3-cff4-422e-b044-7947836f5c21' },
                               { label: 'על האמן - אוהד לוי ',             audio: 'https://firebasestorage.googleapis.com/v0/b/visiteindormuseum.appspot.com/o/hiddenRealms%2F2.mp3?alt=media&token=ccb71c2c-74ac-4c95-961f-3817e6dd10d7', image: 'https://firebasestorage.googleapis.com/v0/b/visiteindormuseum.appspot.com/o/hiddenRealms%2FWhatsApp%20Image%202026-04-23%20at%2011.48.34.jpeg?alt=media&token=be9ba407-b872-47d7-b133-d5cb901eb7af' },
                { label: 'קיר הקמעות',                   audio: 'https://firebasestorage.googleapis.com/v0/b/visiteindormuseum.appspot.com/o/hiddenRealms%2F5.mp3?alt=media&token=fe836772-86ad-42ff-b66b-e4dca19d4381',  image: 'https://firebasestorage.googleapis.com/v0/b/visiteindormuseum.appspot.com/o/hiddenRealms%2FpetitePiece.png?alt=media&token=467398ff-388b-4503-a032-8a65bdf51d7d' },
                { label: 'חוג הארנב',                    audio: 'https://firebasestorage.googleapis.com/v0/b/visiteindormuseum.appspot.com/o/hiddenRealms%2F4.mp3?alt=media&token=a88d4004-a37f-43b2-9eee-5579790e2f68',                image: 'https://firebasestorage.googleapis.com/v0/b/visiteindormuseum.appspot.com/o/hiddenRealms%2FWhatsApp%20Image%202026-04-23%20at%2011.54.13.jpeg?alt=media&token=49ebe230-5453-4e70-86bf-6bd50a24b4da' },
                { label: 'צפונות',                    audio: 'https://firebasestorage.googleapis.com/v0/b/visiteindormuseum.appspot.com/o/hiddenRealms%2F1.mp3?alt=media&token=3c311489-0b01-4b56-9d97-090f7b749b7f',               image: 'https://firebasestorage.googleapis.com/v0/b/visiteindormuseum.appspot.com/o/hiddenRealms%2FpetitePiece2.png?alt=media&token=0a3e2434-e305-4477-805f-b046aa737c2a' },
                  ],
            audioElements: [],
            currentlyPlayingIndex: null,
        };
    },

    computed: {
        loading() {
            return this.$store.getters.loading;
        },
        error() {
            return this.$store.getters.error;
        },

    },
    methods: {
        isPlaying(index) {
            return this.currentlyPlayingIndex === index
        },
        toggleAudio(index) {
    const audioUrl = this.artworks[index].audio; // On récupère l'audio dans l'objet

    if (this.currentlyPlayingIndex !== null) {
        if (this.currentlyPlayingIndex === index) {
            if (this.audioElements[index].paused) {
                this.audioElements[index].play();
            } else {
                this.audioElements[index].pause();
            }
        } else {
            if (this.audioElements[this.currentlyPlayingIndex]) {
                this.audioElements[this.currentlyPlayingIndex].pause();
                this.audioElements[this.currentlyPlayingIndex].currentTime = 0;
            }
            this.audioElements[index] = new Audio(audioUrl);
            this.audioElements[index].play();
            this.currentlyPlayingIndex = index;
        }
    } else {
        this.audioElements[index] = new Audio(audioUrl);
        this.audioElements[index].play();
        this.currentlyPlayingIndex = index;
    }
}
    //    toggleAudio(index) {
      //      console.log("indexHE", index)
        //    if (this.currentlyPlayingIndex !== null) {
          //      if (this.currentlyPlayingIndex === index) {
    //                if (this.audioElements[index].paused) {
     //                   this.audioElements[index].play();
    //                } else {
    //                    this.audioElements[index].pause();
//                    }
  //              } else {
    //                if (this.audioElements[this.currentlyPlayingIndex]) {
      //                  this.audioElements[this.currentlyPlayingIndex].pause();
        //                this.audioElements[this.currentlyPlayingIndex].currentTime = 0;
//                    }
  //                  this.audioElements[index] = new Audio(this.audioFiles[index]);
    //                this.audioElements[index].play();
      //              this.currentlyPlayingIndex = index;
        //        }
//            } else {
  //              this.audioElements[index] = new Audio(this.audioFiles[index]);
    //            this.audioElements[index].play();
      //          this.currentlyPlayingIndex = index;
//            }
 //       },

    },

};
</script>

<style scoped>
.links {
    color: white !important;
    text-decoration: none !important
}

.linksToWebsite {
    color: white !important;
    text-decoration: none !important
}

.siteButton {
    background: #63C4C3;
    width: 300px;
    margin: 0 auto;
    height: 40px;
    font-size: 20px;
    font-family: Heebo;
    border-radius: 3px;
    padding-top: 5px;
    color: white !important;
    text-decoration: none !important
}

.siteButton:active {
    text-decoration: none !important
}


.soundNumber {
    color: black;
    font-size: 27px;
    position: relative;
    bottom: 16px;
}

.playPause {
    position: absolute;
    top: 19px;
    /* left: calc(50% - 10px); */
    right: 24px;
    color: #63C4C3;
}

.presented {
    color: white;
    font-size: 30px;
    font-weight: bold;
    position: relative;
    bottom: 11px;
    text-align: left;
    left: 58px;
}

.itemSquare {
    height: 100px;
    width: 100px;
    border: solid 1px #63C4C3;
    background-color: white;
    border-radius: 20px;
    box-shadow: 0px 0px 20px 3px #80808026;
}

.audioButtonWide {
    width: 100%;
    border: solid 1px #63C4C3;
    border-radius: 15px;
    height: 80px;
    box-shadow: 0px 0px 20px 3px #80808026;
    overflow: hidden;
    cursor: pointer;
}

.audioButtonImg {
    height: 80px;
    width: 80px;
    object-fit: cover;
    flex-shrink: 0;
    border-radius: 14px 0 0 14px;
}

.audioButtonLabel {
    font-size: 16px;
    font-weight: 600;
    font-family: Heebo;
    text-align: right;
}

.titleListName {
    position: absolute;
    top: -45px;
    width: 200px;
    background: white;
    height: 37px;
    z-index: 30;
    margin: 0 auto;
    width: 100%;
    text-align: center;
    padding-top: 5px;
    font-size: 20px;
}

.captionArrow {
    position: absolute;
    font-size: 12px;
    top: 23px;
    left: 30px;
}

.audioButton {
    width: 100%;
    border: 2px #79a541 solid;
    border-radius: 25px;
    height: 40px;
    margin-bottom: 16px;
    position: relative;
}

.titleSpan {
    padding-left: 10px;
    padding-right: 10px;
    padding-bottom: 10px;
    color: #63C4C3;
    text-align: center;
    font-weight: bold;
}



/* .closingCross {
  position: absolute;
  top: -45px;
  right: 16px;
  z-index: 20;
  color: black;
  font-size: 24px;
  z-index: 50;
} */

.closingCross {
    position: relative;
    top: 0px;
    right: 39px;
    z-index: 20;
    color: black;
    font-size: 16px;
    z-index: 50;
}

.fontHeebo {
    font-family: Heebo;
}

@font-face {
    font-family: Heebo;
    src: url(../../static/Heebo/Heebo-VariableFont_wght.ttf);
}

.fontPacifico {
    font-family: Pacifico;
}

@font-face {
    font-family: Pacifico;
    src: url(../../static/Pacifico/Pacifico-Regular.ttf);
}
</style>
